import Controller, { OnClick, OnMount, OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';
import { MountEvent, SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Inject } from '@odinjs/odin';
import { DeckAPI, FilterAPI } from '@philips-internal/oswald-ui-components';
import BaseController from '../../BaseController';
import { SubmittableFragmentContext } from '@philips-internal/oswald-ui-core/lib/component/context';
import { ContextType } from '@philips-internal/oswald-ui-core';
import './diagnosis-description.css';
@Controller({ component: 'main-layout', fragment: 'diagnosis-description' })
export default class DiagnosisDescriptionController extends BaseController {

  @Inject(ContextType.SUBMITTABLE_FRAGMENT)
  submittableFragmentContext!: SubmittableFragmentContext;

  @Inject('diagnosis-deck')
  diagnosisDeck!: DeckAPI;

  @Inject('disease-filter')
  filterDiseaseApi!: FilterAPI;

  @OnClick({ target: 'select-button' })
  onSelectButtonClick(): void {

    const submitableEvent = {
      record: this.diagnosisDeck.getSelectedCards()[0]
    };

    if (submitableEvent.record) {
      this.submittableFragmentContext.submit(new SubmitEvent(submitableEvent));
    }
  }

  @OnMount({ target: 'main-layout' })
  onMountLayout(): void {
    this.filterDiseaseApi.restoreState(true);
  }

  @OnUnmount({ target: 'disease-filter' })
  onFilterUnmount(event: MountEvent): void {
    const filterDisease = event.target as FilterAPI;
    filterDisease.persistState();
  }
}
